
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.169 19.434"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_28910","data-name":"Path 28910","d":"M9.428 4.287a3 3 0 015.145 0l6.7 11.169A3 3 0 0118.7 20H5.3a3.08 3.08 0 01-2.906-2.246 2.792 2.792 0 01.333-2.3z","transform":"rotate(90 11.136 8.864)","fill":"#fff"}})])
          )
        }
      }
    